import { FC, useEffect, useState } from "react";
import { appInsights, reactPlugin, withAITracking } from "../../../appInsights";
import "./social-determinants.scss";
import Intellectual from "./intellectual";
import HousingAndNutrition from "./housing-and-nutrition";
import Ethnicity from "./ethnicity";
import OccupationalFinancial from "./occupational-financial";
import memberDetailsService from "@services/memberDetails.service";
import membersService from "@services/members.service";
import { routeMap } from "@utils/constants";
import { useNavigate } from "react-router-dom";
import { Spin } from "antd";
import HealthemSpinner from "@components/healthemSpinner/healthemSpinner";
import Icon from "@assets/icon_config";

const SocialDeterminants: FC<any> = (props) => {
  const [loadingForSocial, setSocialFlag] = useState(false);
  const [socialData, setSocialData] = useState<any>({});
  const navigate  = useNavigate();
  const defaultExpandedCards = ["12"];
  const expandAllCards = ["9", "10", "11", "12"];
  const [activePanels, setActivePanels] = useState<any>(defaultExpandedCards);
  const patientId = membersService?.getCurrentMember?.patient_id;

  useEffect(() => {
    console.log("SocialDeterminants.useEffect");
    appInsights.trackPageView({name:"Social Determinants"});
  },[]);

  useEffect(() => {
    setActivePanels(defaultExpandedCards);
    if(patientId){
      getSocialData(patientId);
    }else 
    navigate(routeMap["members"])
  },[patientId, navigate])

 
  const getSocialData = (id: number) => {
    setSocialFlag(true);
    memberDetailsService.getSocialDeterminantsInfo(id).subscribe({
      next: (v) => {
        setSocialFlag(false);
        setSocialData(v?.data?.data?.item)
      },
      error: (e) => {
        setSocialFlag(false);
        setSocialData({})

      },
    });
  };

  const changeCollapse = () => {
    if(activePanels?.length > 0) {
      setActivePanels([])
    } else {
      setActivePanels(expandAllCards)
    }
  }

  return (
    <>
      <div className="member-detail-tab-header">
        <div className="member-detail-tab-header__collapse-all-button" onClick={changeCollapse}>
          <span className="member-detail-tab-header__collapse-all-button__title">{activePanels?.length > 0 ? "Collapse All" : "Expand All"}{" "}</span>
          <span className={`member-detail-tab-header__collapse-all-button__arrow ${activePanels?.length > 0 ? "" : "arrow-down"}`}>
            <Icon name={`${activePanels?.length > 0 ? "arrowUp" : "arrowDown"}`} colorOfBrand={"#0072E3"} />
          </span>
        </div>
      </div>
    <div className='ui-s-d'>
      <OccupationalFinancial data={socialData?.occupationalAndFinancial} pinChangeHandler={props.pinChangeHandler} pinCardIds={props.pinCardIds} activeKey={activePanels} setActivePanels={setActivePanels} loading={loadingForSocial}/>
      <Intellectual data={socialData?.intellectual} pinChangeHandler={props.pinChangeHandler} pinCardIds={props.pinCardIds} activeKey={activePanels} setActivePanels={setActivePanels} loading={loadingForSocial}/>
      <HousingAndNutrition data={socialData?.housingAndNutrition} pinChangeHandler={props.pinChangeHandler} pinCardIds={props.pinCardIds} activeKey={activePanels} setActivePanels={setActivePanels} loading={loadingForSocial}/>
      <Ethnicity data={socialData?.ethnicity} pinChangeHandler={props.pinChangeHandler} pinCardIds={props.pinCardIds} activeKey={activePanels} setActivePanels={setActivePanels} loading={loadingForSocial}/>
    </div>
    </>
  );
};

export default withAITracking(reactPlugin, SocialDeterminants);
